import { HttpParams } from "@angular/common/http";

export function getQueryString(params) {
  let httpParams = new HttpParams()
  Object.keys(params).forEach(key => {
    httpParams = httpParams.set(key, (params[key] !== null) ? params[key] : '');
  })
  return httpParams
}
